import styled, { css } from 'styled-components';
import { pxToRem } from '@fil-react-mixins/styled';
import BaseButton from './BaseButton';
export const PrimaryButton = styled(BaseButton) `
  ${({ theme }) => css `
    color: ${theme.color.font.button.contrast.primary.base.value};
    background-color: ${theme.color.button.primary.base.value};

    &:hover {
      color: ${theme.color.font.button.contrast.primary.hover.value};
      background-color: ${theme.color.button.primary.hover.value};
    }

    &:focus {
      color: ${theme.color.font.button.contrast.primary.focus.value};
      background-color: ${theme.color.button.primary.focus.value};
    }

    &:active {
      color: ${theme.color.font.button.contrast.primary.active.value};
      background-color: ${theme.color.button.primary.active.value};
    }

    &[disabled],
    &:disabled {
      background-color: ${theme.color.button.disabled.base.value};
      color: ${theme.button.primaryColorDisabled};

      &:focus,
      &:hover,
      &:active {
        background-color: ${theme.color.button.disabled.base.value};
        color: ${theme.button.primaryColorDisabled};
      }
    }
  `}
`;
PrimaryButton.displayName = 'PrimaryButton';
export const SecondaryButton = styled(BaseButton) `
  ${({ theme }) => css `
    color: ${theme.color.font.button.contrast.secondary.base.value};
    background-color: ${theme.color.button.secondary.base.value};

    &:hover {
      color: ${theme.color.font.button.contrast.secondary.hover.value};
      background-color: ${theme.color.button.secondary.hover.value};
    }

    &:focus {
      color: ${theme.color.font.button.contrast.secondary.focus.value};
      background-color: ${theme.color.button.secondary.focus.value};
    }

    &:active {
      color: ${theme.color.font.button.contrast.secondary.active.value};
      background-color: ${theme.color.button.secondary.active.value};
    }

    &[disabled],
    &:disabled {
      background-color: ${theme.color.button.disabled.base.value};
      color: ${theme.button.secondaryColorDisabled};

      &:focus,
      &:hover,
      &:active {
        background-color: ${theme.color.button.disabled.base.value};
        color: ${theme.button.secondaryColorDisabled};
      }
    }
  `}
`;
SecondaryButton.displayName = 'SecondaryButton';
export const TertiaryButton = styled(BaseButton) `
  ${({ theme }) => css `
    color: ${theme.color.font.button.contrast.tertiary.base.value};
    background-color: ${theme.color.button.tertiary.base.value};

    &:hover {
      color: ${theme.color.font.button.contrast.tertiary.hover.value};
      background-color: ${theme.color.button.tertiary.hover.value};
    }

    &:focus {
      color: ${theme.color.font.button.contrast.tertiary.focus.value};
      background-color: ${theme.color.button.tertiary.focus.value};
    }

    &:active {
      color: ${theme.color.font.button.contrast.tertiary.active.value};
      background-color: ${theme.color.button.tertiary.active.value};
    }

    &[disabled],
    &:disabled {
      background-color: ${theme.color.button.disabled.base.value};
      color: ${theme.button.tertiaryColorDisabled};

      &:focus,
      &:hover,
      &:active {
        background-color: ${theme.color.button.disabled.base.value};
        color: ${theme.button.tertiaryColorDisabled};
      }
    }
  `}
`;
TertiaryButton.displayName = 'TertiaryButton';
export const LinkButton = styled(BaseButton) `
  ${({ theme, svgIcon }) => css `
    background: transparent;
    padding: 0;
    color: ${theme.color.link.base.value};
    margin: 0;
    transition: background-color 0.15s ease 0s, color 0.15s ease 0s;
    outline-offset: 0;
    border: none;

    &:hover {
      color: ${theme.color.link.hover.value};
    }

    &:focus {
      color: ${theme.color.link.focus.value};
    }

    &:active {
      color: ${theme.color.link.active.value};
    }

    ${({ underline = true }) => underline &&
    css `
        text-decoration: underline 0.09375em;
        text-underline-offset: 0.25em;
      `}

    &:hover,
    &:focus,
    &:active {
      ${({ underlineOnHover = true }) => underlineOnHover &&
    css `
          text-decoration: underline 0.09375em;
          text-underline-offset: 0.25em;
        `}
    }

    ${svgIcon &&
    css `
      text-decoration: none;

      &:hover,
      &:focus,
      &:active {
        text-decoration: none;
      }
    `}

    .fil-icon::after {
      font-size: ${({ iconSize = 12 }) => pxToRem(iconSize)};
      margin-left: ${pxToRem(8)};
    }

    &:disabled,
    &[disabled] {
      color: ${theme.color.link.disabled.value};

      &:focus,
      &:hover,
      &:active {
        border: none;
        color: ${theme.color.link.disabled.value};
      }
    }
  `}
`;
LinkButton.displayName = 'LinkButton';
export default PrimaryButton;
